import React from "react";
import { Image } from "@chakra-ui/react";
import InputArea from "./ResearchBlocks/elements/InputArea";
import stock from './assets/stock2.svg';
import hiker from './assets/hiker.svg';
import news from './assets/news.svg';

const suggestions = [
    {
        id: 1,
        name: "Stock analysis on ",
        icon: stock,
    },
    {
        id: 2,
        name: "Help me plan an adventure to ",
        icon: hiker,
    },
    {
        id: 3,
        name: "What are the latest news on ",
        icon: news,
    },
];

const Hero = ({
                  promptValue,
                  setPromptValue,
                  handleDisplayResult,
              }) => {
    const handleClickSuggestion = (value) => {
        setPromptValue(value);
    };

    return (
        <div>
            <div className="flex flex-col items-center justify-center">
                <div className="landing flex flex-col items-center justify-center" style={{ minHeight: '30vh' }}>
                    <h1 className="text-4xl font-extrabold text-center lg:text-7xl" style={{ lineHeight: '3rem' }}>
                        Deep Research, Delivered Instantly
                    </h1>
                    <h2 style={{color: '#7bc4e1', fontFamily: 'Lato', fontWeight: 'bold'}} className="text-xl font-light text-center ml-[20vw] mr-[20vw] mb-10">
                        Ask Ozmosys AI Assistant anything. Get a sourced report in minutes.
                    </h2>
                </div>

                {/* Input section */}
                <div className="w-full max-w-[708px] pb-6 mt-20">
                    <InputArea
                        promptValue={promptValue}
                        setPromptValue={setPromptValue}
                        handleSubmit={handleDisplayResult}
                    />
                </div>

                {/* Suggestions section */}
                <div
                    className="flex flex-wrap items-center justify-center gap-2.5 pb-[30px] lg:flex-nowrap lg:justify-normal">
                    {suggestions.map((item, i) => (
                        <div
                            className="flex h-[35px] cursor-pointer items-center justify-center gap-[5px] rounded border border-solid border-[#C1C1C1] bg-[#EDEDEA] px-2.5 py-2"
                            onClick={() => handleClickSuggestion(item?.name)}
                            key={item.id}
                        >
                            <Image
                                src={item.icon}
                                alt={item.name}
                                width={18}
                                height={16}
                                className="w-[18px]"
                            />
                            <span className="text-sm font-light leading-[normal] text-[#1B1B16]">
                                {item.name}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Hero;
